module.exports = __webpack_public_path__ + "img/vertical_1_1_7005.563da158.png";